import React from "react";

export default function TeamCard({
  name,
  image,
  skills,
  mailHref,
  linkedinHref,
}) {
  return (
    <div className="shadow rounded-lg md:p-5 md:pt-8 lg:p-7 lg:pt-10 md:pb-3 lg:pb-4 p-7 pb-3 md:ml-0 md:mr-0 ml-3 mr-3">
      <div className="flex md:flex-col flex-row md:space-y-2 lg:space-y-4 space-x-6 md:space-x-0 md:pr-3 lg:pr-5 md:pl-3 lg:pl-5">
        <div>
          <img
            className="w-36 h-36 rounded-full mx-auto object-cover"
            src={image}
            alt={name}
          />
        </div>
        <div className="flex">
          <div className="m-auto">
            <h3 className="md:text-center text-xl font-semibold leading-8">
              {name}
            </h3>
            <div className="md:text-center text-xs">
              <p>{skills.join(" | ")}</p>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="md:pt-5 lg:pt-7 text-primary flex flex-row justify-end space-x-3">
          <a href={mailHref}>
            <i className="fa fa-envelope"></i>
          </a>
          <a href={linkedinHref} target="_blank">
            <i className="fa fa-linkedin"></i>
          </a>
        </div>
      </div>
    </div>
  );
}
